<template>
	<div style="display: inline-block;">
		<Button class="jxyd-borderbtn jxyd-searchbtn" title="添加商品" @click="openSelectCommodityModal"
			style="margin-right:10px;">
			<Icon type="md-add-circle" size='18' /> 添加
		</Button>
		<Modal v-model="selectCommodityModal" draggable sticky scrollable :fullscreen="fullscreen" :width="1300"
			:styles="{top: '20px','backgroud-color':'white'}">
			<p slot="header" class="modal-header">
				<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
				<span style="float: left;font-weight: bold;">选取商品</span>
			</p>
			<div class="modal-content">
				<div style="padding: 16px;">
					<div id="box-search">
						<div class="box-search-left">
							<Input type="text" class="search_input" v-model="searchItems.name" placeholder="请输入商品名/条码"
								@keyup.enter.native="initCommodityList(1)" />
							<button class="jxyd-button jxyd-primary jxyd-searchbtn"
								@click="initCommodityList(1)">查询</button>
							<label class="jxyd-a" @click="advancedQuery = true">&nbsp;高级查询</label>
						</div>
						<Button class="jxyd-borderbtn box-search-right" @click="addCommodity" v-show="permission.isAdd">
							新建商品
						</Button>
					</div>
					<Table stripe :height='500' :columns="commodityColumn" :data="commodityData"
						@on-select="listSelected" @on-select-cancel='listSelectedCanel' @on-select-all='listSelectAll'
						@on-select-all-cancel='listSelectAllCanel'>
					</Table>
					<div id="page-box">
						<Page show-sizer :total="commodityCount" :page-size="searchItems.pageSize"
							@on-change="pageChange" show-total show-elevator :page-size-opts='pageSizeOpts'
							:current="searchItems.pageIndex" @on-page-size-change='pageSizeChange'>
						</Page>
					</div>
				</div>

				<!-- 使用封装的自定义抽屉组件 -->
				<CustomDrawer v-model="shoppingCart" :title="`已选商品`" :width="700" placement="right" :mask="true"
					:mask-closable="true" :closable="true" @close="handleDrawerClose">
					<template #title>
						<div class="drawer-title">
							<div class="drawer-title-left">
								已选
								<span class="drawer-title-left-number">
									{{commoditySelected.length}}
								</span>
							</div>
							<div class="drawer-title-right" @click="cleanSelected">清空已选</div>
						</div>
					</template>

					<div>
						<Table :height='680' disabled-hover :columns="selectedColumn" :data="commoditySelected">
						</Table>
					</div>
				</CustomDrawer>

				<!-- 使用封装的自定义抽屉组件 -->
				<CustomDrawer v-model="advancedQuery" :title="`高级查询`" :width="300" placement="right" :mask="true"
					:mask-closable="true" :closable="true">
					<template #title>
						<div class="drawer-title">
							<div class="drawer-title-left">
								<Icon type="ios-search" :size='18' />
								高级查询
							</div>
							<div class="drawer-title-right"></div>
						</div>
					</template>
					<div class="drawer-content">
						<div class="drawer-content-item content-left-right-split">
							<label>商品种类&nbsp;</label>
							<selectTree v-model="searchItemsType" :treeData="commodityTypeData" :border='false'
								style="flex: 1;">
							</selectTree>
						</div>
						<div class="drawer-content-item content-left-right-split">
							<label>所属仓库&nbsp;</label>
							<Select size="small" style="flex: 1;" placeholder="请选择" filterable clearable
								v-model="searchItems.depotId" @keyup.enter.native="initListData(1)">
								<Option :value="0" :key="0">请选择</Option>
								<Option v-for="item in depotList" :value="item.id" :key="item.id">
									{{ item.depotName }}
								</Option>
							</Select>
						</div>
						<div class="drawer-content-item content-left-right-split">
							<label>商品状态&nbsp;</label>
							<Select v-model="searchItems.isUse" size="small" style="flex: 1;" clearable
								placeholder="请选择">
								<Option :value="-1" key="请选择">
									请选择
								</Option>
								<Option :value="1" key="已启用">
									已启用
								</Option>
								<Option :value="0" key="已停用">
									已停用
								</Option>
							</Select>
						</div>
						<div class="drawer-content-item content-left-right-split">
							<label>商品规格&nbsp;</label>
							<input type="text" placeholder="请输入" class="content-input" v-model="searchItems.format" />
						</div>
						<div class="drawer-content-item content-left-right-split">
							<label>备注&nbsp;</label>
							<input type="text" placeholder="请输入" v-model="searchItems.note" class="content-input" />
						</div>
					</div>
					<template #footer>
						<button class="jxyd-button" @click="advancedQuery = false"
							style="margin-right: 10px;">取消</button>
						<button class="jxyd-button jxyd-primary" type="primary"
							@click="initCommodityList(1)">确定</button>
					</template>
				</CustomDrawer>
			</div>
			<div slot="footer">
				<div class="selected-goods" @click="toggleShoppingCart">
					<Icon type="md-cart" size='20' />
					<span>已选:&nbsp;{{commoditySelected.length}}种</span>
				</div>
				<div class="footer-tool">
					<button class="jxyd-button" @click="selectCommodityModal = false">取消</button>
					<button class="jxyd-button jxyd-primary" type="primary" @click="Submit">确定</button>
				</div>
			</div>
		</Modal>
		<!-- 使用封装的图片预览子组件 -->
		<ImagePreview ref="imagePreview" :images="previewImagesList" :visible.sync="previewVisible"
			:initial-index="currentImageIndex" @change="onPreviewImageChange" />
	</div>
</template>

<script>
	import request from '@/utils/request'
	import selectTree from '@/components/selectTree'
	import ImagePreview from '@/components/ImagePreview' // 导入图片预览子组件
	import CustomDrawer from '@/components/CustomDrawer' // 导入自定义抽屉组件
	import formatNum from '@/utils/formatNum'

	export default {
		name: 'selectSKUModal',
		props: ['selectedCommodity','selectedBeforeCheck'],
		components: {
			ImagePreview,
			CustomDrawer,
			selectTree
		},
		computed: {
			searchItemsType: {
				get() {
					this.$nextTick(() => {
						if (this.searchItems.type.length > 0) {
							return this.searchItems.type[0];
						}
						return [];
					})
				},
				set(newVal) {
					if (newVal) {
						this.searchItems.type = [newVal];
					} else {
						this.searchItems.type = [];
					}
				}
			}
		},
		data() {
			return {
				selectCommodityModal: false,
				fullscreen: false,
				commodityTypeData: [],
				commodityColumn: [{
						type: 'selection',
						width: 60,
						align: 'center',
						fixed: 'left'
					}, {
						title: '商品图片',
						key: 'imgs',
						width: 100,
						render: (h, params) => {
							return [h('div', {
								style: {
									'width': '40px',
									'height': '40px',
									'cursor': 'pointer'
								},
								on: {
									click: (val) => {
										this.previewSkuImages(params.row.commodityPriceTypeGroup
											.imgFiles && params.row.commodityPriceTypeGroup
											.imgFiles.length > 0 ? params.row
											.commodityPriceTypeGroup.imgFiles : params.row
											.commodityPriceTypeGroup.commodity.imgFile);
									}
								}
							}, [h('Avatar', {
								style: {
									'width': '100%',
									'height': '100%',
								},
								attrs: {
									'src': this.getImgList(params.row),
								}
							})])];
						}
					},
					{
						title: '商品',
						key: 'name',
						width: 250,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.selectCommodityModal = false;
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodityPriceTypeGroup
													.commodity.id
											}
										});
									}
								}
							}, params.row.commodityPriceTypeGroup.commodity.name);
						}
					},
					{
						title: '规格',
						key: 'priceType',
						width: 250,
					},
					{
						title: '当前库存',
						key: 'stock',
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.row) + params.row
								.commodityPriceTypeGroup.commodity.unit);
						}
					},
					{
						title: '采购价',
						key: 'intoPrice',
						render: (h, params) => {
							return h('span', {}, params.row.intoPrice + '元');
						}
					},
					{
						title: '零售价',
						key: 'retailPrice',
						render: (h, params) => {
							return h('span', {}, params.row.retailPrice + '元');
						}
					},
					{
						title: '批发价',
						key: 'wholesalePricePrice',
						render: (h, params) => {
							return h('span', {}, params.row.wholesalePricePrice + '元');
						}
					}
				],
				commodityData: [],
				commodityCount: 0,
				searchItems: {
					name: '',
					code: '',
					format: '',
					isUse: -1,
					depotId: 0,
					note: '',
					type: [],
					sort: '',
					pageSize: 10,
					pageIndex: 1
				},
				advancedSelect: false,
				shoppingCart: false,
				selectedColumn: [{
						title: '商品图片',
						key: 'imgs',
						width: 100,
						render: (h, params) => {
							return [h('div', {
								style: {
									'width': '40px',
									'height': '40px',
									'cursor': 'pointer'
								},
								on: {
									click: (val) => {
										this.previewSkuImages(params.row.commodityPriceTypeGroup
											.imgFiles && params.row.commodityPriceTypeGroup
											.imgFiles.length > 0 ? params.row
											.commodityPriceTypeGroup.imgFiles : params.row
											.commodityPriceTypeGroup.commodity.imgFile);
									}
								}
							}, [h('Avatar', {
								style: {
									'width': '100%',
									'height': '100%',
								},
								attrs: {
									'src': this.getImgList(params.row),
								}
							})])];
						}
					},
					{
						title: '商品',
						key: 'name',
						width: 180,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.selectCommodityModal = false;
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodityPriceTypeGroup
													.commodity.id
											}
										});
									}
								}
							}, params.row.commodityPriceTypeGroup.commodity.name);
						}
					},
					{
						title: '规格',
						key: 'priceType',
						width: 180,
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 120,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.row) + params.row
								.commodityPriceTypeGroup.commodity.unit);
						}
					},
					{
						title: '采购价',
						key: 'intoPrice',
						width: 120,
						render: (h, params) => {
							return h('span', {}, params.row.intoPrice + '元');
						}
					},
					{
						title: '零售价',
						key: 'retailPrice',
						width: 120,
						render: (h, params) => {
							return h('span', {}, params.row.retailPrice + '元');
						}
					},
					{
						title: '批发价',
						key: 'wholesalePricePrice',
						width: 120,
						render: (h, params) => {
							return h('span', {}, params.row.wholesalePricePrice + '元');
						}
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						fixed: 'right',
						width: 120,
						render: (h, params) => {
							let btnArray = [];
							btnArray.push(h('a', {
								class: 'jxyd-a',
								props: {},
								style: {
									'margin-right': '10px'
								},
								on: {
									click: (val) => {
										this.removeSelectedItem(params.row.index);
									}
								}
							}, "删除"));
							return btnArray;
						}
					}
				],
				pageSizeOpts: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
				permission: {
					isAdd: false
				},
				// 图片预览相关 - 简化后的变量
				previewVisible: false,
				previewImagesList: [],
				currentImageIndex: 0,
				advancedQuery: false,
				depotList: [],
				commodityTypePid: 'spzl',
				commoditySelected: [],
				selectedSKU: false
			}
		},
		methods: {
			listSelectAll(items) {
				let isExist = false;
				for (let i = 0; i < items.length; i++) {
					isExist = false;
					for (let n = 0; n < this.commoditySelected.length; n++) {
						if (items[i].id === this.commoditySelected[n].id) {
							isExist = true;
							break;
						}
					}
					if (!isExist) {
						this.commoditySelected.push(items[i]);
					}
				}
			},
			listSelectAllCanel(items) {
				for (let i = 0; i < this.commodityData.length; i++) {
					for (let n = 0; n < this.commoditySelected.length; n++) {
						if (this.commodityData[i].id === this.commoditySelected[n].id) {
							this.commoditySelected.splice(n, 1);
							break;
						}
					}
				}
			},
			initSelectedRow() {
				this.commodityData.forEach((item2, index2) => {
					if (item2.commodityPriceTypeGroup.commodity.isUse == false) {
						item2._disabled = true;
					}
					this.commoditySelected.forEach((item, index) => {
						if (item.id == item2.id) {
							item2._checked = true;
						}
					});
				});
			},
			listSelected(items, row) {
				this.commoditySelected.push(row);
			},
			listSelectedCanel(items, row) {
				this.commoditySelected.forEach((item, index) => {
					if (row.id == item.id) {
						this.commoditySelected.splice(index, 1);
					}
				});
			},
			cleanSelected() {
				this.commoditySelected = [];
				this.initCommodityList(1);
			},
			getImgList(data) {
				if (data.commodityPriceTypeGroup.imgFiles && data.commodityPriceTypeGroup.imgFiles.length > 0) {
					return data.commodityPriceTypeGroup.imgFiles[0].url;
				}
				if (data.commodityPriceTypeGroup.commodity.imgFile && data.commodityPriceTypeGroup.commodity.imgFile
					.length > 0) {
					return data.commodityPriceTypeGroup.commodity.imgFile[0].url;
				}
				return '/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png';
			},
			// 切换购物车抽屉显示状态
			toggleShoppingCart() {
				this.shoppingCart = !this.shoppingCart;
			},
			getCurrentIStock(data) {
				let commodityInventorys = data.commodityPriceTypeGroup.commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					stock += commodityInventorys[i].stock;
				}
				return formatNum(stock);
			},
			// 处理抽屉关闭事件
			handleDrawerClose() {
				this.shoppingCart = false;
			},

			// 删除已选商品
			removeSelectedItem(index) {
				this.commoditySelected.splice(index, 1);
				this.initCommodityList(this.searchItems.pageIndex);
			},
			initCommodityType() {
				let self = this;
				request.get('/api/DataDictionary/GetTreeOfDataDictionary', {
					params: {
						code: self.commodityTypePid
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "初始化界面失败"
						});
						console.log("获取导航树数据失败：" + response.errorMsg)
						return;
					}
					self.commodityTypeData = [];
					self.formatTypeData(self.commodityTypeData, response.data);
				}).catch(function(error) {})
			},
			formatTypeData(dataArray, array) {
				for (var i = 0; i < array.length; i++) {
					dataArray.push({
						id: array[i].id,
						title: array[i].title,
						value: array[i].path,
						expand: array[i].expand,
						selected: array[i].selected,
						note: array[i].note,
						path: array[i].path,
						children: []
					});
					if (array[i].children && array[i].children.length > 0) {
						this.formatTypeData(dataArray[i].children, array[i].children);
					}
				}
			},
			Submit() {
				if (this.commoditySelected.length < 1) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择商品"
					});
					return;
				}
				this.$emit('getResult', this.commoditySelected);
				this.selectCommodityModal = false;
			},
			openSelectCommodityModal() {
				if(this.selectedBeforeCheck){
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: this.selectedBeforeCheck
					});
					return;	
				}
				this.commoditySelected = JSON.parse(JSON.stringify(this.selectedCommodity));
				this.initCommodityList(1);
				this.selectCommodityModal = true;
			},
			initCommodityList(index) {
				this.searchItems.pageIndex = index;
				request.post('/api/Commodity/GetCommodityFormatList2', this.searchItems).then(response => {
					if (response.state == 0) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					this.commodityData = response.data.commodity;
					this.commodityCount = response.data.commodityCount;
					this.initSelectedRow();
				}).catch(function(error) {})
			},
			pageChange(index) {
				this.initCommodityList(index);
			},
			pageSizeChange(pageSize) {
				this.searchItems.pageSize = pageSize;
				this.initCommodityList(1);
			},
			addCommodity() {
				this.selectCommodityModal = false;
				this.$router.push({
					path: 'commodityfunc'
				});
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['Commodity.Add'],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'Commodity.Add':
								self.permission.isAdd = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			/**
			 * 预览SKU图片 - 简化版本，使用子组件
			 */
			previewSkuImages(images) {
				if (!images || images.length === 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "暂无图片"
					});
					return;
				}

				this.previewImagesList = images;
				this.currentImageIndex = 0;
				this.previewVisible = true;
			},
			/**
			 * 图片切换事件
			 */
			onPreviewImageChange(index, image) {
				this.currentImageIndex = index;
			},
			initDepotData() {
				let self = this;
				request.get('/api/Depot/GetDepotList').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取仓库数据失败：" + response.errorMsg
						});
						return;
					}
					self.depotList = response.data;
				}).catch(function(error) {})
			},
			getCommodityQuantity(data) {
				let quantity = 0;
				for (let i = 0; i < this.commoditySelected.length; i++) {
					if (this.commoditySelected[i].commodity.id == data.id) {
						for (let n = 0; n < this.commoditySelected[i].data.length; n++) {
							quantity += this.commoditySelected[i].data[n].quantity;
						}
					}
				}
				return formatNum(quantity);
			}
		},
		watch: {
			'commoditySelected': {
				deep: true,
				handler(arr) {}
			}
		},
		created: function() {
			this.initPermission();
			this.initDepotData();
			this.initCommodityType();
		},
		beforeDestroy() {}
	}
</script>

<style scoped>
	.modal-content {
		min-height: 500px;
	}

	#page-box {
		margin-top: 15px;
		text-align: center;
	}

	.selected-goods {
		float: left;
		height: 52px;
		line-height: 52px;
		text-align: center;
		width: auto;
		padding: 0px 10px;
		color: #fff;
		background-color: rgb(255, 106, 127);
		font-size: 15px;
		cursor: pointer;
		font-weight: bold;
		border-radius: 0px 0px 0px 6px;
	}

	/deep/ .ivu-modal-footer {
		padding: 0px !important;
		background-color: rgba(255, 255, 255, 0) !important;
	}

	.selected-sku {
		float: left;
		height: 32px;
		line-height: 32px;
		text-align: center;
		width: auto;
		padding: 0px 10px;
		color: rgb(255, 106, 127);
		font-size: 15px;
		cursor: pointer;
		font-weight: bold;
		border-radius: 0px 0px 0px 6px;
	}

	.footer-tool {
		padding: 10px;
	}

	/deep/ .ivu-badge-count {
		top: -3px;
	}

	/deep/ .ivu-modal-content {
		background-color: white;
	}

	/deep/ .ivu-modal-body {
		padding: 0px;
	}

	#box-search {
		margin-bottom: 15px;
		overflow: hidden;
	}

	.search_input {
		width: 200px;
		margin-right: 15px;
	}

	.box-search-left {
		float: left;
	}

	.box-search-right {
		float: right;
	}

	.modal-header {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		overflow: hidden;
		color: rgb(255, 106, 127);
	}

	/* 抽屉内容区域样式 */
	.drawer-content {
		padding: 10px;
	}

	.drawer-content-item {}

	.drawer-content-item+.drawer-content-item {
		border-top: 1px solid #e8e8e8;
		padding-top: 10px;
		margin-top: 10px;
	}

	.drawer-content-item /deep/ div {
		border: none !important;
	}

	.content-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
		flex: 1;
		text-align: right;
		margin: 0px 15px;
	}
</style>